import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@atomic';
import styled from '@emotion/styled';

const CounterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
`;

const Counter = ({ info }) => (
  <CounterWrapper>
    <Text style={{ cursor: 'pointer' }}>{info.title}</Text>
    <Text strong style={{ cursor: 'pointer' }}>
      {info.counter}
    </Text>
  </CounterWrapper>
);

Counter.propTypes = {
  info: PropTypes.object.isRequired,
};

export default Counter;
